import { forwardRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Envelope, Github, Linkedin } from "react-bootstrap-icons";
import "../styles/footer.css";
import motolaLogo from "../assets/motola-logo-looped.svg";
import Contacts from "./Contacts";
import { trackEvent } from "../utils/analytics";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Skills", href: "#skills" },
  { label: "Projects", href: "#projects" },
  { label: "Contact", href: "#contacts", active: true },
];

const socialLinks = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/ron-motola/",
    icon: Linkedin,
    external: true,
    eventName: "click_linkedin",
  },
  {
    label: "GitHub",
    href: "https://github.com/ronM3",
    icon: Github,
    external: true,
    eventName: "click_github",
  },
  {
    label: "Email",
    href: "mailto:ron00003@gmail.com",
    icon: Envelope,
    external: false,
    eventName: "click_email",
  },
];

export const Footer = forwardRef((props, contactsSection) => {
  return (
    <footer className="footer" id="contacts" ref={contactsSection}>
      <Container fluid className="footer__fluid px-lg-0 px-3">
        <Row className="justify-content-center footer__row">
          <Col lg={10} className="footer__col">
            <div className="footer__container">
              <Contacts />

              <div className="footer__divider" aria-hidden="true">
                <span />
              </div>

              <div className="footer__band">
                <a
                  className="footer__logoLink"
                  href="#home"
                  aria-label="Ron Motola home"
                >
                  <img
                    className="footer__logo"
                    src={motolaLogo}
                    alt="MOTOLA"
                    width="170"
                    height="34"
                  />
                </a>

                <div
                  className="footer__nav"
                  role="navigation"
                  aria-label="Footer navigation"
                >
                  {navLinks.map((link) => (
                    <a
                      className={`footer__navLink${
                        link.active ? " footer__navLink--active" : ""
                      }`}
                      href={link.href}
                      key={link.label}
                    >
                      {link.label}
                    </a>
                  ))}
                </div>

                <div className="footer__socials" aria-label="Social links">
                  {socialLinks.map((link) => {
                    const Icon = link.icon;
                    return (
                      <a
                        className="footer__socialLink"
                        href={link.href}
                        key={link.label}
                        target={link.external ? "_blank" : undefined}
                        rel={link.external ? "noreferrer" : undefined}
                        aria-label={link.label}
                        onClick={() => {
                          trackEvent(link.eventName, {
                            location: "contact_or_footer",
                          });
                        }}
                      >
                        <Icon aria-hidden="true" />
                      </a>
                    );
                  })}
                </div>
              </div>

              <div className="footer__meta">
                <p>&copy; 2026 Ron Motola</p>
                <p>Based in Tel Aviv &middot; UTC+3</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
});
